import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
type ServiceType = 'foretagsbestallningar' | 'tartbestallning' | 'catering';
interface NavigationProps {
  onOrderClick: (type: ServiceType) => void;
}
export function Navigation({
  onOrderClick
}: NavigationProps) {
  const [isOpen, setIsOpen] = useState(false);
  const handleLinkClick = (type: ServiceType) => {
    onOrderClick(type);
    setIsOpen(false);
  };
  const links: {
    label: string;
    type: ServiceType;
  }[] = [{
    label: 'Företagsbeställningar',
    type: 'foretagsbestallningar'
  }, {
    label: 'Tårtbeställning',
    type: 'tartbestallning'
  }, {
    label: 'Catering',
    type: 'catering'
  }];
  return <nav className="sticky top-0 z-40 w-full bg-[#1A1A1A] text-[#FFF8F0] shadow-md" data-id="element-160">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <div className="flex justify-between items-center h-14" data-id="element-162">
          {/* Logo / Brand */}
          <div className="flex-shrink-0 flex items-center" data-id="element-163">
            <span className="font-serif text-lg font-bold text-[#C5A55A] tracking-wide" data-id="element-164">
              Top Notch Bakery
            </span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-165">
            <button onClick={() => window.scrollTo({
            top: 0,
            behavior: 'smooth'
          })} className="text-sm font-medium text-[#FFF8F0]/80 hover:text-[#C5A55A] transition-colors" data-id="element-166">
              Hem
            </button>
            {links.map(link => <button key={link.type} onClick={() => handleLinkClick(link.type)} className="text-sm font-medium text-[#FFF8F0]/80 hover:text-[#C5A55A] transition-colors" data-id="element-167">
                {link.label}
              </button>)}
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-168">
            <button onClick={() => setIsOpen(!isOpen)} className="p-2 rounded-md text-[#FFF8F0] hover:bg-[#FFF8F0]/10 focus:outline-none" aria-label="Meny" data-id="element-169">
              {isOpen ? <X className="h-6 w-6" data-id="element-170" /> : <Menu className="h-6 w-6" data-id="element-171" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu Panel */}
      {isOpen && <div className="md:hidden bg-[#1A1A1A] border-t border-[#FFF8F0]/10 animate-in slide-in-from-top-2 duration-200" data-id="element-172">
          <div className="px-2 pt-2 pb-3 space-y-1" data-id="element-173">
            <button onClick={() => {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          setIsOpen(false);
        }} className="block w-full text-left px-3 py-3 rounded-md text-base font-medium text-[#FFF8F0] hover:bg-[#FFF8F0]/10 hover:text-[#C5A55A]" data-id="element-174">
              Hem
            </button>
            {links.map(link => <button key={link.type} onClick={() => handleLinkClick(link.type)} className="block w-full text-left px-3 py-3 rounded-md text-base font-medium text-[#FFF8F0] hover:bg-[#FFF8F0]/10 hover:text-[#C5A55A]" data-id="element-175">
                {link.label}
              </button>)}
          </div>
        </div>}
    </nav>;
}